export default "__VITE_ASSET__BdQhAJx6__"